export default __webpack_public_path__ + "static/investment-6ac06f1d7cc2e8ee1a14e0f9723fd086.png";